import { CurbZoneMapMode, CurbZonePageAttribute, CurbZonePageModeType } from "@/modules/curb-zone/curb-zone.type";
import { DrawLineStringMode, DrawPolygonMode, ModifyMode, ViewMode } from "@deck.gl-community/editable-layers";

type CurbZoneModeConstructor = typeof ViewMode | typeof DrawLineStringMode | typeof DrawPolygonMode | typeof ModifyMode;

export const curbZoneCursorCell: CurbZonePageModeType[] = [
  CurbZonePageModeType.Add,
  CurbZonePageModeType.AddCurbArea,
  CurbZonePageModeType.AddParkingLot,
  CurbZonePageModeType.AddWorkArea,
];

export const parkingLotMode: CurbZoneMapMode[] = [
  CurbZonePageModeType.AddParkingLot,
  CurbZonePageModeType.EditParkingLot,
];
export const curbAreaMode: CurbZoneMapMode[] = [CurbZonePageModeType.AddCurbArea, CurbZonePageModeType.EditCurbArea];
export const workAreaMode: CurbZoneMapMode[] = [CurbZonePageModeType.AddWorkArea, CurbZonePageModeType.EditWorkArea];

export const curbZoneGeoJsonLayerModes: CurbZonePageAttribute<CurbZoneModeConstructor> = {
  view: ViewMode,
  addCurbZone: DrawLineStringMode,
  editCurbZone: ModifyMode,
  multiEditCurbZone: ModifyMode,
  addCurbArea: DrawPolygonMode,
  editCurbArea: ModifyMode,
  addParkingLot: DrawPolygonMode,
  editParkingLot: ModifyMode,
  addWorkArea: DrawPolygonMode,
  editWorkArea: ModifyMode,
};
